import { mountComponent } from '../util/mount';
import { HtmlId } from '../enums/elementId';
import { createRelatedLinks } from '@vfde-brix/ws10/related-links';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';

export const mountRelatedLinks = (id: HtmlId) => mountComponent(
    id,
    createRelatedLinks,
    NO_PATTERN_BUSINESS_LOGIC,
);
